module.exports = __webpack_public_path__ + "static/media/dimentha-approach.0f46500e.svg";